"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var Notifier = /** @class */ (function () {
    function Notifier(opt) {
        this.types = {
            info: {},
            warning: {},
            success: {
                toastClass: 'success-alert-message',
                closeButton: false,
                debug: false,
                newestOnTop: false,
                positionClass: "toast-top-right",
                preventDuplicates: true,
                tapToDismiss: true,
                timeOut: "2500",
                showDuration: "4000",
                showEasing: "swing",
                hideEasing: "linear",
                showMethod: "fadeIn",
                hideMethod: "fadeOut"
            },
            error: {
                toastClass: 'error-alert-message',
                closeButton: false,
                debug: false,
                newestOnTop: false,
                positionClass: "toast-top-right",
                preventDuplicates: true,
                tapToDismiss: true,
                timeOut: "2500",
                showDuration: "4000",
                showEasing: "swing",
                hideEasing: "linear",
                showMethod: "fadeIn",
                hideMethod: "fadeOut"
            }
        };
        this.config = _.defaults(opt, this.types);
    }
    Notifier.prototype.info = function (msg, tl, cfgOvr) {
        this.notify('info', msg, tl, cfgOvr);
    };
    Notifier.prototype.success = function (msg, tl, cfgOvr) {
        this.notify('success', msg, tl, cfgOvr);
    };
    Notifier.prototype.warning = function (msg, tl, cfgOvr) {
        this.notify('warning', msg, tl, cfgOvr);
    };
    Notifier.prototype.error = function (msg, tl, cfgOvr) {
        this.notify('error', msg, tl, cfgOvr);
    };
    Notifier.prototype.notify = function (lvl, msg, tl, cfgOvr) {
        var cfg = this.config[lvl];
        if (cfgOvr) {
            cfg = _.defaults(cfgOvr, cfg);
        }
        // @ts-ignore
        window.toastr[lvl](msg, tl, cfg);
    };
    return Notifier;
}());
exports.default = Notifier;
